export default __webpack_public_path__ + "static/media/003-advice.bd649196.svg";